<template>
  <el-card
    v-loading="isloading"
    style="border: none"
    shadow="never"
    :body-style="{ padding: '10px' }"
  >
    <div slot="header" class="thirdlog-chart-header">
      <span class="thirdlog-chart-header-title">
        第三方接口记录
        <span v-if="info.total">({{ info.total }})</span>

        <el-tooltip :content="`响应时间超过${form.elapsedTime}ms定义为超时`">
          <i
            class="el-icon-warning"
            style="color: #e6a23c; margin-left: 3px; font-size: 1em"
          ></i>
        </el-tooltip>
      </span>

      <div class="time-button-group">
        <span
          v-for="btn of timebuttons"
          :key="btn.value"
          class="time-button"
          :class="{ 'is-selected': timebutton.selected === btn.value }"
          @click="timebutton.selected = btn.value"
        >
          {{ btn.label }}
        </span>
      </div>

      <div v-show="timebutton.selected < 0" class="date-picker">
        <el-date-picker
          v-model="range"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          size="mini"
          @change="loaddata"
        />
      </div>
    </div>

    <!-- <el-form size="small" label-suffix=": " label-position="left" style="margin-top: 10px">
            <el-row :gutter="12">
                <el-col :span="7">
                    <el-form-item>
                        <el-select v-model="form.dataSource" placeholder="数据源" :loading="isOptLoading"
                            @focus="loaddatasource0" style="width: 100%" clearable>
                            <el-option v-for="source in sources || []" :key="source.value" :value="source.value"
                                :label="source.label"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :span="5">
                    <el-form-item>
                        <el-input v-model="form.elapsedTime" placeholder="耗时" style="width: 100%" class="elapsed-time">
                            <template slot="append">ms</template>
                        </el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="12" style="text-align: right;">
                    <el-form-item>
                        <el-button icon="el-icon-search" :loading="isloading" circle type="primary" @click="loaddata" />
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form> -->

    <el-table
      :data="info.list || []"
      row-key="path"
      max-height="400"
      height="400"
    >
      <el-table-column type="expand">
        <thirdlog-chart-item
          slot-scope="scope"
          :items="scope.row.items"
          @loadrequest="loadrequest0"
        />
      </el-table-column>
      <el-table-column prop="dataSource" label="数据源" width="200" />
      <el-table-column prop="path" label="路径" />
      <el-table-column label="数量(超时/总数量)" width="120" align="right">
        <div slot-scope="scope">
          <span class="info-elapsed-count">{{
            scope.row.elapsedCount || 0
          }}</span>
          <span>/</span>
          <span class="info-count">{{ scope.row.count }}</span>
        </div>
      </el-table-column>
    </el-table>

    <el-dialog :visible.sync="isdialog" width="40%" append-to-body>
      <thirdlog-detail :log="looking" />
    </el-dialog>
  </el-card>
</template>

<script>
import apiRequest from './api.request'
import dayjs from 'dayjs'
import ThirdlogChartItem from './ThirdlogChartItem.vue'
import ThirdlogDetail from './ThirdlogDetail.vue'

export default {
  components: {
    ThirdlogChartItem,
    ThirdlogDetail,
  },

  mixins: [apiRequest],

  data() {
    return {
      form: {
        dataSource: '',
        btm: '',
        etm: '',
        elapsedTime: '10000',
      },

      sources: null,

      isOptLoading: false,

      isloading: false,

      info: {},

      isdialog: false,
      looking: {},

      timebutton: {
        selected: 0,
      },
    }
  },

  computed: {
    range: {
      get() {
        return [this.form.btm, this.form.etm]
      },

      set(value) {
        value = value || []
        this.form.btm = value[0] || ''
        this.form.etm = value[1] || ''
      },
    },

    timebuttons() {
      return [
        {
          value: 0,
          label: '今日',
        },
        {
          value: 1,
          label: '昨日',
        },
        {
          value: -1,
          label: '自定义',
        },
      ]
    },
  },

  watch: {
    'timebutton.selected': {
      handler(value) {
        if (value >= 0) {
          let d = 1 - value
          let etm = dayjs().add(d, 'd'),
            btm = etm.add(-1, 'd')
          this.range = [btm.format('YYYY-MM-DD'), etm.format('YYYY-MM-DD')]
          this.$nextTick(this.loaddata)
        } else {
          this.range = []
        }
      },
      immediate: true,
    },
  },

  mounted() {
    this.loaddata()
  },

  methods: {
    async loaddatasource0() {
      if (this.sources !== null) {
        return
      }

      this.isOptLoading = true
      try {
        this.sources = (await this.loaddatasource()) || []
      } finally {
        this.isOptLoading = false
      }
    },

    async loaddata() {
      this.isloading = true
      try {
        const resp = await this.$api.post(
          '/schedules/apicallogs/thirdlogs/chart',
          this.form
        )
        if (resp.data.status === 1) {
          this.info = resp.data.content || {}
        }
      } finally {
        this.isloading = false
      }
    },

    async loadrequest0(row) {
      if (!row.looked) {
        this.$set(row, 'loading', true)
        try {
          const resp = await this.loadrequest(row.index, row.id)

          if (resp.data.status === 1) {
            Object.entries(resp.data.content || {}).forEach(([k, v]) =>
              this.$set(row, k, v)
            )
            this.$set(row, 'looked', true)
          } else {
            return this.$message.error(resp.data.message || '查看失败')
          }
        } finally {
          this.$set(row, 'loading', false)
        }
      }

      this.looking = row || {}
      this.isdialog = true
    },
  },
}
</script>

<style lang="scss" scoped>
.info-elapsed-count {
  font-weight: bold;
  margin-right: 5px;
}

.info-count {
  font-weight: bold;
  margin-left: 5px;
}

.thirdlog-chart-header {
  display: flex;
  flex-direction: row;
  height: 30px;
  align-items: center;

  .thirdlog-chart-header-title {
    font-size: 14px;
    font-weight: bold;
    flex-grow: 1;
  }

  .time-button-group {
    font-size: 0;

    .time-button {
      font-size: 13px;
      padding: 5px 8px;
      cursor: pointer;
      color: #333333;
      border-radius: 4px;
      display: inline-block;
      transition: background-color 0.3s;
      margin-right: 3px;

      &:not(.is-selected) {
        &:hover {
          background-color: #efefef;
        }
      }

      &:last-child {
        margin-right: 0;
      }

      &.is-selected {
        color: #fff;
        background-color: #3bafda;
      }
    }
  }

  .date-picker {
    margin-left: 10px;
    width: 220px;

    & > .el-date-editor {
      width: 100%;
    }
  }
}
</style>
